// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"997c0ff8","464":"1f90d5bd","550":"3ef830e6"}[chunkId] + ".chunk.js";
};